import { ICopyCargoUseCase } from "../../../presentation/useCases/create/copy_cargo_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CopyCargoUseCase
 */

export class CopyCargoUseCase implements ICopyCargoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async copyCargo(
    idCargo: number,
    descricao: string,
  ): Promise<void> {
    await this.repository.copyCargo(idCargo, descricao);
  }
}
